export enum PlatformTypes {
  SmsGlobal = 1,
  SmsUSA = 2,
  TwoReward = 3,
  Vendasta = 4
}
